'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React from 'react';
import {ButtonState, isButtonState} from "../../../core-utilities/enums/ButtonState";


export function ModalFooterView(props) {
  return (
    <div className={classNames("ModalFooter", props.className)}>
      <div className="ModalFooter__buttons">
        {props.children}
      </div>
    </div>
  );
}

ModalFooterView.propTypes = {
  className: T.string,
  placeholderLabelClass: T.string,
  showForm: T.bool,
  isModal: T.bool,
  mode: isButtonState,

  onHideForm: T.func,
  onShowForm: T.func,
  onTriggerSave: T.func,

  cancelLabel: T.string,
  createLabel: T.string,
  modalHeaderLabel: T.node,
  placeholderLabel: T.node,
};

ModalFooterView.defaultProps = {
  mode: ButtonState.START,
  cancelLabel: 'Cancel',
  createLabel: "Save",
};



// WEBPACK FOOTER //
// ./src/js/components/modals/ModalFooter/ModalFooterView.js